import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {MeService} from './me.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private loginUrl = 'api/login';
  private logoutUrl = 'api/logout';

  constructor(
    private router: Router,
    private http: HttpClient,
    private meService: MeService,
  ) {
  }

  login(login: string, password: string): Promise<void> {
    const formData = new FormData();
    formData.append('login', login);
    formData.append('password', password);

    return this.http.post(this.loginUrl, formData)
      .toPromise()
      .then(response => this.meService.fetchAll())
      .then(() => this.router.navigate(['/']))
      .then(result => {
      })
      .catch(error => {
        throw error;
      });
  }

  logout(): Promise<void> {
    const formData = new FormData();
    return this.http.post(this.logoutUrl, formData)
      .toPromise()
      .then(response => this.meService.unsetMe())
      .then(() => this.router.navigate(['/login']))
      .then(result => {
      })
      .catch(error => {
        throw error;
      });
  }
}
